// @flow

import {combineReducers} from 'redux';
import {composeReducers} from '../../utils/redux';
import dictionary from './reducers/dictionary';
import evidence from './reducers/evidence';
import features from './reducers/features';
import report from './reducers/report';
import settings from './reducers/settings';
import table from './reducers/table';

export default composeReducers([
  combineReducers({
    table,
    dictionary,
    report,
    settings,
    features,
    evidence
  })
]);
